import React from 'react';
import { Clock } from 'lucide-react';
import { motion } from 'framer-motion';
import { useApp, MOCK_PRODUCTS } from '../context/AppContext';
import { Header } from '../components/ui/Header';
import { ProductCard } from '../components/ui/ProductCard';
export function FlashDealsScreen() {
  const flashDeals = MOCK_PRODUCTS.filter(p => p.discount);
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50" data-id="element-511">
      <Header title="Flash Deals" data-id="element-512" />

      <div className="bg-accent text-white p-4 flex items-center justify-between sticky top-[53px] z-30 shadow-sm" data-id="element-513">
        <div data-id="element-514">
          <h2 className="font-bold text-lg" data-id="element-515">Ending Soon!</h2>
          <p className="text-accent-100 text-sm" data-id="element-516">
            Grab these deals before they're gone
          </p>
        </div>
        <div className="bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-lg flex items-center gap-1.5 font-bold" data-id="element-517">
          <Clock className="w-4 h-4" data-id="element-518" /> 12:45:00
        </div>
      </div>

      <div className="p-4 grid grid-cols-2 gap-4" data-id="element-519">
        {flashDeals.map(product => <ProductCard key={product.id} product={product} data-id="element-520" />)}
        {/* Duplicate for visual fullness in prototype */}
        {flashDeals.map(product => <ProductCard key={`${product.id}-dup`} product={{
        ...product,
        id: `${product.id}-dup`
      }} data-id="element-521" />)}
      </div>
    </motion.div>;
}